export default  {
    component: 'block',
    name: 'block',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Block ID',
        param: 'block_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> Should always start from ID **"1"**.` ,
        
      },
      {
        name: 'Block Name',
        param: 'block_name',
        type: 'text',
        description: `> Should be unique.`
      },
      {
        name: 'AC Capacity',
        param: 'ac_capacity',
        type: 'number',
        description:`> Its a mandatory data for the calculation of **"PR"**. It should be sum of all the inverters capacities present in that specific block.`
      },
      {
        name: 'DC Capacity',
        param: 'dc_capacity',
        type: 'number',
        description:`> - Its a mandatory data. It should be sum of all the inverters capacities present in that specific block.`
      },
      {
        name: 'Irradiance (Ref. device Id)',
        param: 'irr_ref_device_id',
        type: 'number',
        description:`> In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which ws id PoA data exist.`
      },
      {
        name: 'Irradiance (Ref. block Id)',
        param: 'irr_ref_block_id',
        type: 'number',
        description:`> In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which block id the ws id PoA data exist.`
      },      
      {
        name: 'Name',
        param: 'name',
        type: 'text',
      }
    ]
  }

